module.exports = __webpack_public_path__ + "static/media/top-brands-web-icon.30237364.svg";